<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center">
      <h3>赛事管理</h3>
    </div>
    <el-form :inline="!UI.isMobile" :label-position="UI.isMobile ? 'top' : 'right'" size="mini" :model="filterForm">
      <el-form-item label="标题">
        <el-input clearable v-model="filterForm.title" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="主办单位">
        <el-input clearable v-model="filterForm.org" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="描述">
        <el-input clearable v-model="filterForm.desc" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="地址">
        <el-input clearable v-model="filterForm.address" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="报名开始时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="filterForm.sign_start_time" type="date"
          placeholder="选择日期时间"></el-date-picker>
      </el-form-item>

      <el-form-item label="报名截至时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="filterForm.sign_end_time" type="date"
          placeholder="选择日期时间"></el-date-picker>
      </el-form-item>

      <el-form-item label="比赛开始时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="filterForm.game_start_time" type="date"
          placeholder="选择日期时间"></el-date-picker>
      </el-form-item>

      <el-form-item label="比赛截至时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="filterForm.game_end_time" type="date"
          placeholder="选择日期时间"></el-date-picker>
      </el-form-item>

      <el-form-item label="状态">
        <el-select v-model="filterForm.state">
          <el-option :value="item.value" :label="item.label" v-for="(item, key) in $stateConsts" :key="key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="
          page = 1;
        flushData();
        ">
          查询
        </el-button>
        <el-button @click="
          filterForm = { page: 1, page_size: 10 };
        flushData();
        ">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="desc" label="描述">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="
            showContent = scope.row.desc;
          isContentShow = true;
          ">
            点击预览
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="图片">
        <template slot-scope="scope">
          <a :href="scope.row.picture" target="_blank">点击预览</a>
        </template>
      </el-table-column>
      <el-table-column prop="org" label="主办单位"></el-table-column>
      <el-table-column prop="sign_start_time" label="报名开始时间"></el-table-column>
      <el-table-column prop="sign_end_time" label="报名结束时间"></el-table-column>
      <el-table-column prop="game_start_time" label="比赛开始时间"></el-table-column>
      <el-table-column prop="game_end_time" label="比赛结束时间"></el-table-column>
      <el-table-column prop="evidence_picture" label="证书图片">
        <template slot-scope="scope">
          <a :href="scope.row.evidence_picture" target="_blank" v-if="scope.row.evidence_picture">
            点击查看
          </a>
        </template>
      </el-table-column>

      <el-table-column prop="evidence_config" label="证书配置"></el-table-column>

      <el-table-column prop="outs_url" label="赛况链接">
        <template slot-scope="scope" v-if="scope.row.outs_url">
          <a :href="scope.row.outs_url" target="_blank">点击查看</a>
        </template>
      </el-table-column>
      <el-table-column prop="picture_url" label="相册视频">
        <template slot-scope="scope" v-if="scope.row.picture_url">
          <a :href="scope.row.picture_url" target="_blank">点击查看</a>
        </template>
      </el-table-column>
      <el-table-column label="分组/岗位信息">
        <template slot-scope="scope">
          {{ isArray(scope.row.groups) ? scope.row.groups.join(';') : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column label="是否显示">
        <template slot-scope="scope">
          {{ scope.row.is_show ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="state" label="状态">
        <template slot-scope="scope">
          {{ $getStateLabel(scope.row) }}
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="180">
        <template slot="header" slot-scope="scope">
          <el-button @click="
            gameInfo = {};
          isShow = true;
          " type="primary" size="small">
            发布赛事
          </el-button>
        </template>
        <template slot-scope="scope">
          <el-button @click="
            gameInfo = scope.row;
          gameInfo.groups = scope.row.groups && isArray(scope.row.groups)
            ? scope.row.groups.join(';')
            : scope.row.groups;
          defaultContent = scope.row.desc;
          isShow = true;
          " type="primary" size="small">
            编辑
          </el-button>
          <el-button @click="handleDeleteGame(scope.row.id)" type="danger" size="small">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination :hide-on-single-page="total <= filterForm.page_size" @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page" :page-size="filterForm.page_size" layout="total, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>

    <el-dialog title="查看" :visible.sync="isContentShow" show-close :fullscreen="UI.isMobile">
      <div v-html="showContent"></div>
    </el-dialog>

    <el-dialog title="发布赛事" :visible.sync="isShow" :fullscreen="UI.isMobile" show-close>
      <div class="flex flex-direction align-center gameinfo">
        <el-form ref="gameInfoForm" :model="gameInfo" :rules="gameInfoRules"
          :label-position="UI.isMobile ? 'top' : 'left'" :label-width="UI.isMobile ? undefined : '120px'"
          style="width: 90%;">
          <el-form-item label="赛事标题" prop="title">
            <el-input placeholder="请输入标题" clearable v-model="gameInfo.title"></el-input>
          </el-form-item>
          <el-form-item label="是否显示">
            <el-select v-model="gameInfo.is_show">
              <el-option :value="true" label="是"></el-option>
              <el-option :value="false" label="否"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="主办单位" prop="org">
            <el-input placeholder="请输入" clearable v-model="gameInfo.org"></el-input>
          </el-form-item>

          <el-form-item label="图片" prop="picture">
            <MediaUpload ref="picture" :action="uploadUrl + '/upload/games'" :suffixList="[]" :file="gameInfo.picture"
              @success="handlerUploadSuccess('picture')"></MediaUpload>
          </el-form-item>

          <el-form-item label="报名开始时间" prop="sign_start_time">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="gameInfo.sign_start_time" type="datetime"
              placeholder="选择日期时间"></el-date-picker>
          </el-form-item>

          <el-form-item label="报名结束时间" prop="sign_end_time">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="gameInfo.sign_end_time" type="datetime"
              placeholder="选择日期时间"></el-date-picker>
          </el-form-item>

          <el-form-item label="比赛开始时间" prop="game_start_time">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="gameInfo.game_start_time" type="datetime"
              placeholder="选择日期时间"></el-date-picker>
          </el-form-item>

          <el-form-item label="比赛结束时间" prop="game_end_time">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="gameInfo.game_end_time" type="datetime"
              placeholder="选择日期时间"></el-date-picker>
          </el-form-item>

          <el-form-item label="地址" prop="address">
            <el-input clearable v-model="gameInfo.address" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="分组/岗位信息" prop="groups">
            <el-input clearable v-model="gameInfo.groups" placeholder="请输入分组/岗位信息，用英文分号分割"></el-input>
          </el-form-item>

          <el-form-item label="证书图片" prop="evidence_picture">
            <MediaUpload ref="evidence_picture" :action="uploadUrl + '/upload/download'" :suffixList="['.png', '.jpg']"
              :file="gameInfo.evidence_picture" @success="handlerUploadSuccess('evidence_picture')"></MediaUpload>
          </el-form-item>

          <el-form-item label="证书配置" prop="evidence_config">
            <el-input placeholder="请输入标题" clearable v-model="gameInfo.evidence_config"></el-input>
          </el-form-item>

          <el-form-item label="赛况链接" prop="outs_url">
            <el-input placeholder="请输入标题" clearable v-model="gameInfo.outs_url"></el-input>
          </el-form-item>

          <el-form-item label="相册视频" prop="picture_url">
            <el-input placeholder="请输入标题" clearable v-model="gameInfo.picture_url"></el-input>
          </el-form-item>

          <el-form-item label="赛事描述" prop="desc">
            <ParseEdit ref="edit" @onChange="editOnChange" :defaultContent="defaultContent"></ParseEdit>
          </el-form-item>
        </el-form>

        <el-button class="login-button padding-xs margin-top" type="primary" size="mini" @click="submit()">
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGamesList, addGame, deleteGame } from '@/servers/admin.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import ParseEdit from '@/components/parseEdit.vue';
import MediaUpload from '@/components/upload/mediaUpload.vue';
import { baseUrl } from '@/utils/consts.js';
import { isArray } from '@/utils/typeUtils.js';

export default {
  components: {
    ParseEdit,
    MediaUpload,
  },

  data() {
    return {
      uploadUrl: baseUrl,
      isContentShow: false,
      showContent: '',
      defaultContent: '',
      gameInfo: {},
      isShow: false,
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
      gameInfoRules: {
        title: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        org: [
          {
            required: true,
            message: '请输入主办单位',
            trigger: 'blur',
          },
        ],
        picture: [
          {
            required: true,
            message: '请上传图片',
            trigger: 'blur',
          },
        ],
        desc: [
          {
            required: true,
            message: '请输入描述',
            trigger: 'blur',
          },
        ],
        sign_start_time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur',
          },
        ],
        sign_end_time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur',
          },
        ],
        game_start_time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur',
          },
        ],
        game_end_time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '请输入地址',
            trigger: 'blur',
          },
        ],
        groups: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
        // evidence_picture: [
        //   {
        //     required: true,
        //     message: '请上传',
        //     trigger: 'blur',
        //   },
        // ],
        // evidence_config: [
        //   {
        //     required: true,
        //     message: '请上传',
        //     trigger: 'blur',
        //   },
        // ],
      },
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    isArray,
    handlerUploadSuccess: function (key) {
      this.gameInfo[key] = this.$refs[key].uploadRes;
    },

    flushData: function () {
      let that = this;
      this.page = 1;
      getGamesList(this.filterForm, function (res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function () {
      this.flushData();
    },

    editOnChange: function (content) {
      this.gameInfo.desc = content;
    },

    handleDeleteGame: function (fileId) {
      let that = this;
      this.$confirm('确认删除(记录)?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          deleteGame(fileId, function (res) {
            showSuccessMsg(res);
            that.flushData();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消',
          });
        });
    },

    submit: function () {
      let that = this;
      this.$refs.gameInfoForm.validate((valid) => {
        if (valid) {
          addGame(this.gameInfo, function (res) {
            that.gameInfo = {};
            that.isShow = false;
            that.flushData();
            showSuccessMsg(res);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.gameinfo {
  .el-form-item__content {
    line-height: unset !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/games/games.vue